import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth, roleHome } from "@/context/AuthContext";
import AuthCallback from "@/pages/AuthCallback";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import ClientDashboard from "@/pages/client/Dashboard";
import Booking from "@/pages/client/Booking";
import Bookings from "@/pages/client/Bookings";
import Chat from "@/pages/client/Chat";
import CoachDashboard from "@/pages/coach/CoachDashboard";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import PaymentSuccess from "@/pages/payment/Success";
import PaymentCancel from "@/pages/payment/Cancel";

const Loader = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="w-16 h-16 rounded-full zenith-cta animate-breathe" data-testid="app-loader" />
  </div>
);

function Protected({ roles, children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={roleHome(user.role)} replace />;
  return children;
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/app" element={<Protected roles={["client"]}><ClientDashboard /></Protected>} />
      <Route path="/app/book" element={<Protected roles={["client"]}><Booking /></Protected>} />
      <Route path="/app/bookings" element={<Protected roles={["client"]}><Bookings /></Protected>} />
      <Route path="/app/chat" element={<Protected roles={["client"]}><Chat /></Protected>} />
      <Route path="/coach" element={<Protected roles={["coach", "admin"]}><CoachDashboard /></Protected>} />
      <Route path="/admin" element={<Protected roles={["admin"]}><AdminDashboard /></Protected>} />
      <Route path="/payment/success" element={<Protected roles={["client"]}><PaymentSuccess /></Protected>} />
      <Route path="/payment/cancel" element={<Protected roles={["client"]}><PaymentCancel /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
